// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"1":"f9d85c22","680":"705e694e","707":"2fe878ba","836":"9c7a7430","939":"cec50d8a"}[chunkId] + ".chunk.js";
};